import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class CountReportItemEntity extends Entity {
    constructor() {
        super(...arguments);
        this.countAmount = 0;
        this.countDate = new Date(0);
    }
    pk() {
        return `${this.constructor.key}:${this.countDate}`;
    }
}
CountReportItemEntity.schema = {
    countDate: ISODate
};
export { CountReportItemEntity };
class AccountReportDecryptionChartEntity extends CountReportItemEntity {
}
AccountReportDecryptionChartEntity.key = 'AccountReportDecryptionChart';
export { AccountReportDecryptionChartEntity };
class AccountReportEncryptionChartEntity extends CountReportItemEntity {
}
AccountReportEncryptionChartEntity.key = 'AccountReportEncryptionChart';
export { AccountReportEncryptionChartEntity };
/** Shared shape for usage & access report rows (counts aggregate and per-day items). */
export class UsageAndAccessReportItemEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        this.authorizedUserCount = 0;
        this.geofencingSetCount = 0;
        this.preventCopyCount = 0;
        this.preventForwardCount = 0;
        this.preventPrintCount = 0;
        this.preventSaveCount = 0;
        this.revokeCount = 0;
        this.shredCount = 0;
        this.timelineSetCount = 0;
        /** Present on aggregate `counts` rows; may be absent on per-day `items`. */
        this.totalItems = 0;
    }
}
class AccountReportUsageAndAccessEntity extends UsageAndAccessReportItemEntity {
}
AccountReportUsageAndAccessEntity.key = 'AccountReportUsageAndAccess';
export { AccountReportUsageAndAccessEntity };
class OrganizationReportAccountEncryptionAndDecryptionEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        this.decryptionCount = 0;
        this.encryptionCount = 0;
        this.firstName = null;
        this.lastName = null;
        this.userName = '';
    }
}
OrganizationReportAccountEncryptionAndDecryptionEntity.key = 'OrganizationReportAccountEncryptionAndDecryption';
export { OrganizationReportAccountEncryptionAndDecryptionEntity };
class OrganizationReportActiveUsersDailyEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        this.deviceTypeId = 0;
        this.platform = null;
    }
}
OrganizationReportActiveUsersDailyEntity.key = 'OrganizationReportActiveUsersDaily';
export { OrganizationReportActiveUsersDailyEntity };
class OrganizationReportDecryptionChartEntity extends CountReportItemEntity {
}
OrganizationReportDecryptionChartEntity.key = 'OrganizationReportDecryptionChart';
export { OrganizationReportDecryptionChartEntity };
class OrganizationReportEncryptionChartEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        this.decryptionCount = 0;
        this.encryptionCount = 0;
    }
}
OrganizationReportEncryptionChartEntity.key = 'OrganizationReportEncryptionChart';
export { OrganizationReportEncryptionChartEntity };
class OrganizationReportInstallationEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        //   deviceTypeId: number = 0;
        this.platform = null;
    }
}
//   totalItems: number = 0;
OrganizationReportInstallationEntity.key = 'OrganizationReportInstallation';
export { OrganizationReportInstallationEntity };
class OrganizationReportOperationEntity extends CountReportItemEntity {
}
//   deviceTypeId: number = 0;
//   isEncryption: boolean = false;
//   platform: string | null = null;
OrganizationReportOperationEntity.key = 'OrganizationReportOperation';
export { OrganizationReportOperationEntity };
class OrganizationReportRegistrationEntity extends CountReportItemEntity {
    constructor() {
        super(...arguments);
        //   licenseTypeId: number = 0;
        this.name = null;
    }
}
//   totalItems: number = 0;
OrganizationReportRegistrationEntity.key = 'OrganizationReportRegistration';
export { OrganizationReportRegistrationEntity };
class OrganizationReportUsageAndAccessEntity extends UsageAndAccessReportItemEntity {
}
OrganizationReportUsageAndAccessEntity.key = 'OrganizationReportUsageAndAccess';
export { OrganizationReportUsageAndAccessEntity };
